export default {
  页面曝光: {
    f_module: '页面曝光',
    f_resource: '2022体育CNY',
    f_type: 0
  },
  module: function module(_module, resource) {
    return {
      f_module: _module,
      f_resource: resource || _module,
      f_type: _module === resource || !resource ? 1 : 4
    };
  }
};